import { AnimatePresence, motion } from "framer-motion"
import { Outlet } from 'react-router-dom'



type Props = {}

const AuthLayout = (props: Props) => {
    return (
        <div className="min-h-screen flex">
            <motion.div
                className="w-full lg:w-1/2 relative overflow-hidden bg-gradient-to-br to-gray-200"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
            >
                <div className="absolute inset-0 flex items-center justify-center p-8">
                    <motion.div
                        className="relative"
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.3, ease: "easeOut" }}
                    >
                        <div>
                        <h1 className="text-[25px] font-semibold">Join India's Green <br />Energy Revolution!</h1>
                        <p>Tokenize your renewable energy <br />production and ensure every unit is <br />verified, valued, and rewarded.</p>
                        </div>
                    </motion.div>
                </div>
            </motion.div>
            <motion.div
                className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-gradient-to-br from-[#56698F] to-[#56698F] rounded-l-[20px] my-[80px]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
            >
                <div className="w-full max-w-md">
                    
                    <AnimatePresence mode="wait">
                        <motion.div
                            key="login"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 20 }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                        >
                
                                <Outlet />
            
                        </motion.div>
                    </AnimatePresence>
                </div>
            </motion.div>
        </div>
    )
}

export default AuthLayout